import Repository from "../Repository";
import { apiConfig, company } from "../../_helpers/apiHelper";

const resource = "/formula";

export default {
  getFormulas() {
    return Repository.get(`${resource}/all/${company()}`, apiConfig());
  },

  getFormulasByConstant(id) {
    return Repository.get(`${resource}/constant/${id}`, apiConfig());
  },

  getFormulasByTag(deveui) {
    return Repository.get(`${resource}/tag/${deveui}`, apiConfig());
  },

  getFormulasByTagKey(deveui, key) {
    return Repository.get(`${resource}/tagkey/${deveui}/${key}`, apiConfig());
  },

  createOrUpdateFormula(payload) {
    return Repository.post(`${resource}/${company()}`, payload, apiConfig());
  },

  createFormulaUsingImport(payload) {
    return Repository.post(
      `${resource}/import/${company()}`,
      payload,
      apiConfig()
    );
  },

  deleteFormula(id) {
    return Repository.delete(`${resource}/${id}`, apiConfig());
  },

  getFormulaTemplates() {
    return Repository.get(`${resource}/template/all/${company()}`, apiConfig());
  },

  createOrUpdateFormulaTemplate(payload) {
    return Repository.post(
      `${resource}/template/${company()}`,
      payload,
      apiConfig()
    );
  },

  deleteFormulaTemplate(id) {
    return Repository.delete(`${resource}/template/${id}`, apiConfig());
  },

  getConstants() {
    return Repository.get(
      `${resource}/constants/all/${company()}`,
      apiConfig()
    );
  },

  createOrUpdateConstant(payload) {
    return Repository.post(
      `${resource}/constants/${company()}`,
      payload,
      apiConfig()
    );
  },

  deleteConstant(id) {
    return Repository.delete(`${resource}/constants/${id}`, apiConfig());
  },

  deleteConstantForce(id) {
    return Repository.delete(`${resource}/constants/force/${id}`, apiConfig());
  },

  getVariablesFromFormulaString(formulaString) {
    return Repository.post(
      `${resource}/variables-from-string`,
      formulaString,
      apiConfig()
    );
  },

  testFormula(payload) {
    return Repository.post(`${resource}/test-formula`, payload, apiConfig());
  },
};
